export default `query categoryById(
    $id: Int
  ) {
  category (id: $id) {
    url_path
    url_suffix
  }
}`
